import { StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';
import { Column } from 'app/design/primitives/box';
import { BalloonCard } from 'app/design/images/balloon-card';
import { Text } from 'app/design/primitives/text';
import { images } from 'app/design/images';
import { useTranslation } from 'react-i18next';
import { env } from 'app/lib/env';

export default function OneMonthFreeCard() {
  const { t } = useTranslation('invite');

  return (
    <Column style={styles.column}>
      <View style={styles.cardContainer}>
        <BalloonCard height={180} width={312} />
        <Image source={env.IS_PARTAKE ? images.logoThreeLinesPartake : images.logoThreeLines} style={styles.logo} />
        <Text fontWeight="700" variant="bodyBase" alignSelf="center" style={styles.text}>
          {t('referralProgram.referrals.1monthFreeWithEmoji')}
        </Text>
      </View>
    </Column>
  );
}

const styles = StyleSheet.create({
  column: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardContainer: {
    justifyContent: 'center',
  },
  logo: {
    position: 'absolute',
    alignSelf: 'center',
    bottom: 60,
    height: 90,
    width: 90,
  },
  text: {
    position: 'absolute',
    bottom: 35,
  },
});
